import { useState, useRef, forwardRef } from 'react';
import useClickOutside from '/src/hooks/useClickOutside';
import './DropDown.css';

const DropDown = forwardRef(({ choices = [], placeholder, defaultChoice = '', heightFix, className = '', width = 170, name = '', onChange, onBlur, setValue, icon = '', hideSelectItem = true, noChangeOnSelect = false, reverse = false, disabled = false }, ref) => {
    
    if (defaultChoice !== undefined && defaultChoice !== null && defaultChoice !== '') {
        defaultChoice = choices.filter(choice => choice.value == defaultChoice).pop();

    }

    if (placeholder) {
        defaultChoice = { text: placeholder, value: '' }
    }

    var maxWidth = 0;
    if (typeof width === 'number' || width instanceof Number) {
        width = width < 100 ? 100 : width;
        maxWidth = width - 60 + "px";
        width = width + "px"
    }
    else {
        maxWidth = "calc(" + width + " - 60px)";
    }

    if (defaultChoice === undefined || defaultChoice === '') {
        defaultChoice = choices[0]
    }

    const [expanded, setExpanded] = useState(false);
    const [selected, setSelected] = useState(defaultChoice);
    const [lastDefaultChoice, setLastDefaultChoice] = useState(defaultChoice);

    if(lastDefaultChoice.value !== defaultChoice.value) {
        setSelected(defaultChoice);
        setLastDefaultChoice(defaultChoice);
    }

    if(hideSelectItem == true) {
        choices = choices.filter(choice => selected.value != choice.value)
    }
    const listStyle = {
        "overflowY": expanded ? 'auto' : 'hidden',
        "height": expanded ? (heightFix ? heightFix : choices.length * 35 + "px") : '0'

    };

    if(reverse) {
        listStyle.paddingTop = "0px";
        listStyle.bottom = "15px";
    }
    
    const onClick = () => {
        if(!expanded) dropdownRef.current ? dropdownRef.current.style.zIndex = 10 : null;
        else setTimeout(() => dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500)
        setExpanded(!expanded)
    }

    const onSelect = (choice) => {
        if(choice.text === "Import my logo") {
            const fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('name', 'avatar');
            fileInput.click();
            fileInput.addEventListener('change', (event) => {
                const file = event.target.files[0];
                if(setValue) {
                    setValue(name, file , { state: selected, func: setSelected }); 
                    setSelected({ value: file.name, text: file.name });
                }
            });
        } else {
            if(!noChangeOnSelect) setSelected(choice);
            setExpanded(false);
            setTimeout(() => dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500);
            if (!setValue) return;
            setValue(name, choice.value, { state: selected, func: setSelected });
        }
    }

    const dropdownRef = useRef("dropdown");
    useClickOutside(dropdownRef, () => {
        if(expanded) setTimeout(() => dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500)
        setExpanded(false)
    })

    const createChoice = (choice) => {

        var iconPadding = icon ? 30 : 60
        var paddingLeft = 25
        if(choice.icon) {
            paddingLeft = 0
        }

        return (
            <>
                {choice.icon && (
                    typeof choice.icon === 'string'? 
                    <div className="icon" style={{ backgroundImage: `url(${choice.icon})` }}></div> :
                    <div className="icon">{choice.icon}</div> 
                )}
                <span className='text' style={{ fontWeight: selected.value == choice.value ? 700 : 400, maxWidth: "calc(" + width + " - "+ iconPadding +"px)" , paddingLeft}}>{choice.text} </span>
            </>
        )
    }

   
    //[...document.getElementsByClassName('dropdown')].map((element, index) => element.style.zIndex = 0);
    if(disabled) {
        className = className ? className + ' disabled' : 'disabled'
    }
    className = className ? 'dropdown ' + className : 'dropdown';

    var iconBackground = icon ? icon : selected.icon
    var paddingLeft = 25
    if(iconBackground) {
        paddingLeft = 0
    }
    return (
        <div className={className} ref={dropdownRef} style={{ position: 'relative' }}>
            <input ref={ref} onChange={onChange} onBlur={onBlur} name={name} type="hidden" value={selected.value == null ? '' : selected.value}></input>
            <div className="custom-dropdown" style={{ width }} onClick={onClick}>
                {iconBackground && (
                    typeof iconBackground === 'string' ? 
                    <div className="icon" style={{ width: '25px', height : '25px', backgroundImage: `url(${iconBackground})` }}></div> : 
                    <div className="icon" style={{ width: 'auto', backgroundColor : 'white'}}>{iconBackground}</div> 
                )}
                <span className="text" style={{maxWidth, paddingLeft}} >{selected.text}</span>
                <div className='container-arrow'>
                    <div className={`arrow ${expanded ? 'reverse' : ''}`} />
                </div>
                <ul style={{ ...listStyle }}>
                    { choices && choices.map((choice, index) => {
                            return <li key={index} onClick={() => onSelect(choice)}>{createChoice(choice)}</li>
                    })
                }
                </ul>
            </div>
        </div>
    )
});

export default DropDown;